import React from "react";
import PropTypes from "prop-types";

// import router link
import { Link } from "react-router-dom";

// import moment
import moment from "moment";
import "moment/locale/fr";

// import common components
import Lister from "../../common/Lister";

// import utilities
import {
  calculateCol,
  getObjectByKey,
  slugify,
} from "../../../helpers/utilities";

// import dummies
import { ARTICLE_BANNER, COUNTRY, OPPORTUNITY } from "../../../helpers/dummies";

// import constants
import { ITEMS_TO_DISPLAY_XS } from "../../../helpers/constants";

//this is new page is made by merge branch
const ArticleList = ({
  items,
  itemsPerRow,
  listerClasses,
  withDiscover,
  withPagination,
}) => {
  return (
    <React.Fragment>
      <Lister
        listerClasses={`${listerClasses} articles opportunities`}
        withPagination={withPagination}
        withDiscover={withDiscover}
        discoverOptions={{ discoverLink: "#" }}
      >
        {items &&
          items.map((item, index) => {
            
            let itemArticle = {
              ...item,
              views: item.views ? item.views : 0,
              category: item.category ? item.category : "Article",
              image:  ARTICLE_BANNER.image,
              title: item.title ? item.title : "Lorem ipsum",
              publicId:item.publicId ? item.publicId : "1",
              name:item.author ? item.author : ""
            };
           
            return (
              <ArticleItemList
                key={`bourse_item_${index}`}
                // row={calculateCol(itemsPerRow)}
                {...itemArticle}
              />
            );
          })}
      </Lister>
    </React.Fragment>
  );
};
ArticleList.propTypes = {
  items: PropTypes.array,
  itemsPerRow: PropTypes.number,
  listerClasses: PropTypes.string,
  withPagination: PropTypes.bool,
};
ArticleList.defaultProps = {
  itemsPerRow: ITEMS_TO_DISPLAY_XS,
  listerClasses: "g-3 mt-2",
  withDiscover: false,
  withPagination: false,
};
export default ArticleList;

/**
 * Article item.
 */
const ArticleItemList = ({
  col,
  views,
  category,
  image,
  publicId,
  name,
  createdAt,
  title,
  description,
}) => (
  <div className="blog-box">
    <div className="col-lg-12">
      <div className="flex shadow-xl p-0 rounded-sm">
        <div className="article-image">
          <img src={image} alt="alt" className="object-cover" />
        </div>
        <div className="col-lg-6 py-6 px-6 shadow-lg rounded-sm">
          <div className="articles-cards">
            
          <Link
                to={{
                  pathname: `/articles/${slugify(title)}`,
                  state: { code: publicId, name: title },
                }}
              >
            <h1>
            
                {title.length > 20 ? title.substr(0, 19) + "..." : title}
              
            </h1>
            <p>
            {description.length > 80
                ? description.substr(0, 79) + "..."
                : description}
               {description.length > 80 && (
                <span>
                    <br />
                    <Link  to={{
                     pathname: `/articles/${slugify(title)}`,
                     state: { code: publicId, name: title },
                    }}  style={{color:"blue"}}>
                        Read More
                    </Link>
                </span>
            )}
             </p>
            <p className="mt-3">Author:{name}</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
);
